import React, { useState, useEffect } from 'react';
import { InputMask } from '@react-input/mask';
import api from '../../../config/axios';
import Swal from 'sweetalert2';

import { FaRegSave, FaTimes } from 'react-icons/fa';

const ComissaoColaboradorModal = ({ colaborador, onClose }) => {
    const [servicos, setServicos] = useState([]);
    const [marcarTodos, setMarcarTodos] = useState(false);

    const formatarTempo = (tempo) => {
        if (!tempo) return '00:00';
        
        if (tempo.length === 8 && tempo.includes(':')) {
            const [horas, minutos] = tempo.split(':');
            return `${horas}:${minutos}`;
        }
        
        if (tempo.length === 5) {
            return tempo;
        }
        
        return '00:00';
    };

    useEffect(() => {
        fetchServicos();
    }, [colaborador]);

    const fetchServicos = async () => {
        try {
            Swal.fire({
                title: "Carregando...",
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });
            
            const response = await api.get('/servicos?page=1&limit=1000');
            const servicosData = response.data.records || [];
            setServicos(servicosData);
            
            if (colaborador) {
                await fetchComissoesColaborador(servicosData);
            }
            
            Swal.close();
        } catch (error) {
            Swal.close();
            Swal.fire('Erro', 'Erro ao carregar serviços', 'error');
        }
    };

    const fetchComissoesColaborador = async (servicosData) => {
        try {
            const response = await api.get('/servicoColaboradores', {
                params: {
                    page: 1,
                    limit: 1000
                }
            });
            
            const todasComissoes = response.data.records || [];
            const comissoes = todasComissoes.filter(c => c.id_pessoa_colaborador === colaborador.id);
            
            const servicosAtualizados = servicosData.map(servico => {
                const comissao = comissoes.find(c => c.id_servico === servico.id_servico);
                
                return {
                    ...servico,
                    esta_associado: !!comissao,
                    comissao: comissao ? `${parseFloat(comissao.comissao || 0).toFixed(2)}%` : '',
                    comissao_assistente: comissao ? `${parseFloat(comissao.comissao_assistente || 0).toFixed(2)}%` : '',
                    tempo: comissao ? formatarTempo(comissao.tempo) : formatarTempo(servico.tempo)
                };
            });
            
            setServicos(servicosAtualizados);
            
            const todosMarcados = servicosAtualizados.every(servico => servico.esta_associado);
            setMarcarTodos(todosMarcados);
        } catch (error) {
            Swal.fire('Erro', 'Erro ao carregar comissões do colaborador', 'error');
        }
    };

    const handleChangeComissao = (e, index) => {
        const { name, value } = e.target;

        if (name === "comissao" || name === "comissao_assistente") {
            let inputValue = value.replace(/[^0-9.]/g, "");
            if (parseFloat(inputValue) > 100) inputValue = "100";

            const newServicos = [...servicos];
            if (inputValue != '') inputValue = inputValue + "%"
            newServicos[index] = {
                ...newServicos[index],
                [name]: inputValue
            };

            setServicos(newServicos);
        }

        if (name == 'esta_associado') {
            const newServicos = [...servicos];
            newServicos[index].esta_associado = !newServicos[index].esta_associado;
            newServicos[index].comissao = '0%';
            newServicos[index].comissao_assistente = '0%';
            newServicos[index].tempo = formatarTempo(servicos[index].tempo);
            setServicos(newServicos);

            const todosMarcados = newServicos.every(servico => servico.esta_associado);
            setMarcarTodos(todosMarcados);
        }
    };

    const handleMarcarTodos = () => {
        const novoValor = !marcarTodos;
        setMarcarTodos(novoValor);
        const atualizados = servicos.map(servico => ({
            ...servico,
            esta_associado: novoValor,
            comissao: novoValor ? '0%' : '',
            comissao_assistente: novoValor ? '0%' : '',
            tempo: formatarTempo(servico.tempo)
        }));
        setServicos(atualizados);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        for (let i = 0; i < servicos.length; i++) {
            if (servicos[i].esta_associado && servicos[i].comissao.replace(/[^0-9.]/g, "") == '') {
                Swal.fire('Erro', 'Por favor, preencha a comissão dos serviços selecionados', 'error');
                return;
            }
            if (servicos[i].esta_associado && servicos[i].comissao_assistente.replace(/[^0-9.]/g, "") == '') {
                Swal.fire('Erro', 'Por favor, preencha a comissão assistente dos serviços selecionados', 'error');
                return;
            }
        }

        Swal.fire({
            title: "Salvando...",
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            const response = await api.get('/servicoColaboradores', {
                params: {
                    page: 1,
                    limit: 10000
                }
            });
            
            const todasComissoes = response.data.records || [];
            const comissoesExistentes = todasComissoes.filter(c => c.id_pessoa_colaborador === colaborador.id);
            
            for (const comissao of comissoesExistentes) {
                await api.delete(`/servicoColaboradores/${comissao.id}`);
            }

            for (let i = 0; i < servicos.length; i++) {
                if (servicos[i].esta_associado) {
                    const data = {
                        id_servico: servicos[i].id_servico,
                        data: [{
                            id_pessoa_colaborador: colaborador.id,
                            comissao: parseFloat(servicos[i].comissao.replace(/[^0-9.]/g, "")),
                            comissao_assistente: parseFloat(servicos[i].comissao_assistente.replace(/[^0-9.]/g, "")),
                            tempo: servicos[i].tempo
                        }]
                    };
                    
                    await api.post('/servicoColaboradores', data);
                }
            }

            Swal.fire('Sucesso', 'Comissões salvas com sucesso!', 'success');
            onClose();
        } catch (error) {
            Swal.close();
            Swal.fire('Erro', 'Erro ao salvar comissões', 'error');
        }
    };

    return (
        <div className="modal fade show" tabIndex="-1" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered">
                <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                    <div className="modal-header">
                        <h4 className="fw-bold mt-2">Comissões - {colaborador?.nome}</h4>
                        <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
                    </div>

                    <div className="modal-body">
                        <form onSubmit={handleSubmit}>
                            <div className="row mt-3">
                                <div className="col-12">
                                    <div className="table-responsive max-h-400">
                                        <table className="table table-striped">
                                            <thead className="table-custom-primary">
                                                <tr className="thead-fixed">
                                                    <th>
                                                        <div className="form-check d-flex justify-content-center">
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input"
                                                                checked={marcarTodos}
                                                                onChange={handleMarcarTodos}
                                                            />
                                                        </div>
                                                    </th>
                                                    <th>Serviço</th>
                                                    <th>Comissão</th>
                                                    <th>Comissão Assistente</th>
                                                    <th>Tempo</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {servicos.map((servico, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                            <div className="form-check d-flex justify-content-center">
                                                                <input
                                                                    type="checkbox"
                                                                    name="esta_associado"
                                                                    className="form-check-input"
                                                                    checked={servico.esta_associado || false}
                                                                    onChange={(event) => handleChangeComissao(event, index)}
                                                                />
                                                            </div>
                                                        </td>
                                                        <td className="text-nowrap">{servico.nome}</td>
                                                        <td>
                                                            <input
                                                                className="form-control"
                                                                name="comissao"
                                                                autoComplete="off"
                                                                disabled={!servico.esta_associado}
                                                                value={servico.comissao}
                                                                style={{ width: '150px' }}
                                                                onChange={(event) => handleChangeComissao(event, index)}
                                                                placeholder="0%"
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                className="form-control"
                                                                name="comissao_assistente"
                                                                autoComplete="off"
                                                                disabled={!servico.esta_associado}
                                                                value={servico.comissao_assistente}
                                                                style={{ width: '150px' }}
                                                                onChange={(event) => handleChangeComissao(event, index)}
                                                                placeholder="0%"
                                                            />
                                                        </td>
                                                        <td>
                                                            <InputMask
                                                                mask="__:__"
                                                                replacement={{ _: /\d/ }}
                                                                name="tempo"
                                                                className="form-control"
                                                                autoComplete="off"
                                                                disabled={true}
                                                                value={servico.tempo}
                                                                style={{ width: '150px' }}
                                                                placeholder="00:00"
                                                            />
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="modal-footer mt-4">
                        <div className="row">
                            <div className="col-12 text-end">
                                <button className="btn btn-outline-danger" type="button" onClick={onClose}>
                                    <FaTimes /> Fechar
                                </button>
                                <button className="btn btn-custom-primary ms-3" type="submit" onClick={handleSubmit}>
                                    <FaRegSave /> Salvar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default ComissaoColaboradorModal;